export const Pokedex: {[k: string]: ModdedSpeciesData} = {
	pumpkaboosmall: {
		inherit: true,
		unreleasedHidden: true,
	},
	pumpkaboolarge: {
		inherit: true,
		unreleasedHidden: true,
	},
	gourgeistsmall: {
		inherit: true,
		unreleasedHidden: true,
	},
	gourgeistlarge: {
		inherit: true,
		unreleasedHidden: true,
	},
	sinisteaantique: {
		inherit: true,
		unreleasedHidden: true,
	},
	polteageistantique: {
		inherit: true,
		unreleasedHidden: true,
	},
	dracozolt: {
		inherit: true,
		unreleasedHidden: true,
	},
	arctozolt: {
		inherit: true,
		unreleasedHidden: true,
	},
	dracovish: {
		inherit: true,
		unreleasedHidden: true,
	},
	arctovish: {
		inherit: true,
		unreleasedHidden: true,
	},
};
